import React from 'react';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import { InstallationStatusCounter } from '~/api/models/installationStatusCounter';
import { STATISTICS_CONFIG } from '~/features/campaigns/constants/statisticsConfig';
import { FormattedMessage } from 'react-intl';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { useHistory, useLocation } from 'react-router-dom';
import { parseQuery } from '~/features/base/utils/query';

interface StageStatisticsBodyProps {
  statistics?: InstallationStatusCounter;
  stageLoading: boolean;
}

const StageStatisticsBody: React.FC<StageStatisticsBodyProps> = ({ statistics, stageLoading }) => {
  const history = useHistory();
  const location = useLocation();
  const query = parseQuery(location.search);

  const handleStatClick = (installationStatus?: string) => {
    if (installationStatus) {
      const newQuery = { ...query, installationStatus };
      const searchParams = new URLSearchParams(newQuery).toString();
      history.push(`${location.pathname}?${searchParams}`);
    }
  };

  return (
    <>
      {STATISTICS_CONFIG.map((config, index) => (
          <React.Fragment key={config.key}>
            <StatsWidget onClick={() => handleStatClick(config.installationStatus)}
                         style={{ border: 'none', cursor: config.installationStatus ? 'pointer' : 'default' }}>
            <StatsWidget.Header>
              <span className='text-size-14 text-bold'><FormattedMessage id={config.labelId} /></span>
            </StatsWidget.Header>
            <StatsWidget.Body>
              {!stageLoading ?
                  statistics &&
                  <span className={`${config.colorClass} text-size-h3 text-bold`}> {statistics[config.key]} </span> :
                  <ContentLoader width={50}/>}
            </StatsWidget.Body>
          </StatsWidget>
          </React.Fragment>
      ))}
    </>
  );
};

export default StageStatisticsBody;
